/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AcquisitionBucketCountFromJSON, AcquisitionBucketCountToJSON } from './AcquisitionBucketCount';
/**
 * Check if a given object implements the UsersStats interface.
 */
export function instanceOfUsersStats(value) {
    if (!('byAttributionMethod' in value) || value['byAttributionMethod'] === undefined)
        return false;
    if (!('bySource' in value) || value['bySource'] === undefined)
        return false;
    if (!('total' in value) || value['total'] === undefined)
        return false;
    return true;
}
export function UsersStatsFromJSON(json) {
    return UsersStatsFromJSONTyped(json, false);
}
export function UsersStatsFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'byAttributionMethod': (json['by_attribution_method'].map(AcquisitionBucketCountFromJSON)),
        'bySource': (json['by_source'].map(AcquisitionBucketCountFromJSON)),
        'total': json['total'],
    };
}
export function UsersStatsToJSON(json) {
    return UsersStatsToJSONTyped(json, false);
}
export function UsersStatsToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'by_attribution_method': (value['byAttributionMethod'].map(AcquisitionBucketCountToJSON)),
        'by_source': (value['bySource'].map(AcquisitionBucketCountToJSON)),
        'total': value['total'],
    };
}
